var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSort = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.8333H2C1.72667 10.8333 1.5 11.06 1.5 11.3333C1.5 11.6066 1.72667 11.8333 2 11.8333H14C14.2733 11.8333 14.5 11.6066 14.5 11.3333C14.5 11.06 14.2733 10.8333 14 10.8333Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5H4C3.72667 7.5 3.5 7.72667 3.5 8C3.5 8.27333 3.72667 8.5 4 8.5H12C12.2733 8.5 12.5 8.27333 12.5 8C12.5 7.72667 12.2733 7.5 12 7.5Z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 4.16669H6.66675C6.39341 4.16669 6.16675 4.39335 6.16675 4.66669C6.16675 4.94002 6.39341 5.16669 6.66675 5.16669H9.33341C9.60675 5.16669 9.83341 4.94002 9.83341 4.66669C9.83341 4.39335 9.60675 4.16669 9.33341 4.16669Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSort, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sort.b37b32ac.svg";
export { ForwardRef as ReactComponent };